import { useMounted } from '@eturi/react';
import { useContext, useLayoutEffect, useState } from 'react';
import { I18NextContext } from './I18NextProvider';
export function useT(...args) {
    const [keyPrefix, ns] = args;
    const { i18n, isReady, rootT, Text } = useContext(I18NextContext);
    const isMounted = useMounted();
    const ready = isReady(ns);
    const getT = () => {
        if (keyPrefix == null && ns == null)
            return rootT;
        const t = i18n.getFixedT(null, ns || i18n.options.defaultNS || null, keyPrefix);
        return Object.defineProperty(t, '$', {
            value: rootT,
            configurable: false,
            enumerable: false,
            writable: false,
        });
    };
    const [t, setT] = useState(getT);
    useLayoutEffect(() => {
        isMounted() && setT(getT);
    }, [keyPrefix, ns, rootT]);
    if (ready === true) {
        return [t, i18n, Text];
    }
    throw ready;
}
//# sourceMappingURL=useT.js.map